import { createContext, useContext } from 'react';

export interface SessionContextValue {
  meetingOccurrenceId: number | null;
}

export const SessionContext = createContext<SessionContextValue>({ meetingOccurrenceId: null });

export function useSessionOccurrenceId(): number | null {
  return useContext(SessionContext).meetingOccurrenceId;
}
